module.exports = __webpack_public_path__ + "img/index10.71cb1e13.jpg";